import classNames from 'classnames';
import { ButtonDesignType, ComponentType, GetPageComponentViewModel } from '@/types/cml-api';
import { AppNextLink } from '@/features/app-next-link';
import { Button } from '@/features/button';
import { Webengage } from '@/features/webengage';
import { useDataLayerPush } from '../../../_utils/use-datalayer-push';
import { elementTrackingId } from '../contants';
export interface Props {
  data: GetPageComponentViewModel;
  className?: string;
}
export function LandingButton({
  data,
  className
}: Props) {
  const pushToDataLayer = useDataLayerPush();
  const handleClick = () => {
    pushToDataLayer({
      event: elementTrackingId,
      elementType: ComponentType.Button,
      elementIndex: 0,
      itemID: data?.id || '',
      elementName: data?.sortKey,
      destinationUrl: data?.link || '',
      componentId: data?.id,
      ImageUrl: null
    });
    Webengage.trackCtaAction({
      banner_type: ComponentType.Button,
      banner_name: data?.sortKey ?? '',
      banner_index: '0',
      url_destination: data?.link || '',
      item_id: data?.id || '',
      component_id: data?.id ?? ''
    });
  };
  return <AppNextLink href={data?.link || ''} onClick={handleClick} prefetch={false} className={classNames('mx-auto inline-block', className)} data-sentry-element="AppNextLink" data-sentry-component="LandingButton" data-sentry-source-file="button.tsx">
            <Button size='large' graphicStyle={data?.buttonDesignType === ButtonDesignType.Outline ? 'outlined' : 'filled'} className='w-fit' data-sentry-element="Button" data-sentry-source-file="button.tsx">
                {data?.title}
            </Button>
        </AppNextLink>;
}